var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaFacilities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.072 38H27.9282C26.4535 38 25.7161 38 25.0239 38.1048C21.8432 38.5865 18.9209 40.7024 16.8603 44.0156C16.4118 44.7366 16.0028 45.5666 15.1848 47.2267C13.9225 49.7884 13.2912 51.0693 13.0328 52.0477C11.7916 56.748 13.8183 61.8715 17.3977 63.0815C18.1428 63.3333 19.2807 63.3333 21.5565 63.3333H130.443C132.719 63.3333 133.857 63.3333 134.602 63.0815C138.181 61.8715 140.208 56.748 138.967 52.0477C138.709 51.0693 138.077 49.7881 136.815 47.2267C135.997 45.5668 135.588 44.7365 135.139 44.0156C133.079 40.7024 130.156 38.5865 126.976 38.1048C126.283 38 125.546 38 124.072 38Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.072 38H27.9282C26.4535 38 25.7161 38 25.0239 38.1048C21.8432 38.5865 18.9209 40.7024 16.8603 44.0156C16.4118 44.7366 16.0028 45.5666 15.1848 47.2267C13.9225 49.7884 13.2912 51.0693 13.0328 52.0477C11.7916 56.748 13.8183 61.8715 17.3977 63.0815C18.1428 63.3333 19.2807 63.3333 21.5565 63.3333H130.443C132.719 63.3333 133.857 63.3333 134.602 63.0815C138.181 61.8715 140.208 56.748 138.967 52.0477C138.709 51.0693 138.077 49.7881 136.815 47.2267C135.997 45.5668 135.588 44.7365 135.139 44.0156C133.079 40.7024 130.156 38.5865 126.976 38.1048C126.283 38 125.546 38 124.072 38Z",
    stroke: "url(#paint0_linear_16725_951)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88.6667H114",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88.6667H114",
    stroke: "url(#paint1_linear_16725_951)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 63.3333L33.2657 73.3918C37.694 79.0076 39.1206 86.3784 37.101 93.2076L32.8251 107.667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 63.3333L33.2657 73.3918C37.694 79.0076 39.1206 86.3784 37.101 93.2076L32.8251 107.667",
    stroke: "url(#paint2_linear_16725_951)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 63.3333L118.735 73.3918C114.306 79.0076 112.88 86.3784 114.899 93.2076L119.175 107.667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 63.3333L118.735 73.3918C114.306 79.0076 112.88 86.3784 114.899 93.2076L119.175 107.667",
    stroke: "url(#paint3_linear_16725_951)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 120.333C44.3333 127.329 38.6623 133 31.6667 133C24.6711 133 19 127.329 19 120.333C19 113.338 24.6711 107.667 31.6667 107.667C38.6623 107.667 44.3333 113.338 44.3333 120.333Z",
    stroke: "white",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 120.333C44.3333 127.329 38.6623 133 31.6667 133C24.6711 133 19 127.329 19 120.333C19 113.338 24.6711 107.667 31.6667 107.667C38.6623 107.667 44.3333 113.338 44.3333 120.333Z",
    stroke: "url(#paint4_linear_16725_951)",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133 120.333C133 127.329 127.329 133 120.333 133C113.337 133 107.667 127.329 107.667 120.333C107.667 113.338 113.337 107.667 120.333 107.667C127.329 107.667 133 113.338 133 120.333Z",
    stroke: "white",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133 120.333C133 127.329 127.329 133 120.333 133C113.337 133 107.667 127.329 107.667 120.333C107.667 113.338 113.337 107.667 120.333 107.667C127.329 107.667 133 113.338 133 120.333Z",
    stroke: "url(#paint5_linear_16725_951)",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38V25.9895C38 21.4445 41.8721 18.1097 45.8694 19.212L58.5361 22.7051C61.3554 23.4825 63.3333 26.2768 63.3333 29.4825V38",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38V25.9895C38 21.4445 41.8721 18.1097 45.8694 19.212L58.5361 22.7051C61.3554 23.4825 63.3333 26.2768 63.3333 29.4825V38",
    stroke: "url(#paint6_linear_16725_951)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_951",
    x1: 12.6665,
    y1: 38,
    x2: 66.417,
    y2: 114.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_951",
    x1: 38,
    y1: 88.6667,
    x2: 38.208,
    y2: 93.1684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_951",
    x1: 25.3335,
    y1: 63.3333,
    x2: 41.5005,
    y2: 64.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_951",
    x1: 114,
    y1: 63.3333,
    x2: 130.167,
    y2: 64.6488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_951",
    x1: 19,
    y1: 107.667,
    x2: 49.1063,
    y2: 116.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16725_951",
    x1: 107.667,
    y1: 107.667,
    x2: 137.773,
    y2: 116.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16725_951",
    x1: 38,
    y1: 19,
    x2: 66.4464,
    y2: 29.8018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaFacilities);
export default __webpack_public_path__ + "static/media/spa-facilities.c859c373dafe215b41e4824c3bb3f7c8.svg";
export { ForwardRef as ReactComponent };